import React, { ReactNode } from 'react';
// import { curry } from 'ramda';

const cloneChildren = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fn: (idx: number, props: Record<string, any>) => Record<string, any>,
  children: ReactNode
): { count: number; clonedChildren: ReactNode } => {
  let childIndex = 0;
  const clonedChildren = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return null;
    }
    const idx = childIndex++;
    return React.cloneElement(
      child,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      fn(idx, child.props as Record<string, any>)
    );
  }) as ReactNode[];

  return {
    count: childIndex,
    clonedChildren,
  };
};

export default cloneChildren;
